import React from 'react';
import { isUserAnEventActor, hasUserAlreadyPerformedValidation } from 'utils/event-utils';
import { EventFormStore, EventFormViewModel } from 'stores/events/event-form-store';
import { IdentityService } from 'services/identity-service';

interface Props {
  eventFormStore: EventFormStore;
  identityService: IdentityService;
  readOnly: boolean;
  onValidate?: () => void;
}

const EventValidateButtonTw: React.FC<Props> = ({ eventFormStore, identityService, readOnly, onValidate }) => {
  const event: EventFormViewModel = eventFormStore.state.item;
  if (!event) return null;

  const isVisible =
    event.status.toString() !== 'Closed' &&
    event.status.toString() !== 'Completed' &&
    isUserAnEventActor(event) &&
    !hasUserAlreadyPerformedValidation(event) &&
    !IdentityService.isWorker(identityService.getUserInfo());

  if (!isVisible) return null;

  return (
    <button
      type="button"
      className="flex-1 py-2 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm"
      disabled={!readOnly}
      onClick={onValidate}
    >
      Validate
    </button>
  );
};

export default EventValidateButtonTw;
